
import { BaseEditorKit } from "../components/editor/editor-base-kit";
import { EditorStatic } from "../components/ui/editor-static";
import { createSlateEditor } from "platejs";
import { serializeHtml } from "platejs/static";


interface ExportHtmlButtonProps {
    plateValue: any;
}
export const serializeHTMLDocument = async (input: ExportHtmlButtonProps) => {

    const editorStatic = await createSlateEditor({
        plugins: BaseEditorKit,
        //@ts-ignore
        value: input.plateValue
       
    });

    const editorHtml = await serializeHtml(editorStatic, {
        editorComponent: EditorStatic,
        props: { style: { padding: "0 calc(50% - 350px)", paddingBottom: "" } },
    });

    

    return editorHtml
};
